import filterString from './filterString'

export default (string, max, truncatedIndicator = '...') => {
  const filtered = filterString(string)

  return filtered.length > max
    ? filtered.slice(0, max) + truncatedIndicator
    : filtered
}
